import React, { useState } from 'react';

import Plantilla from './plantillas/Plantilla';

const DescargaApp = () => {
    return (<>
        <Plantilla id="DescargaApp"></Plantilla>
    </>);
};

export default DescargaApp;